import {Modal} from '../components/modal';
import { useState, useEffect } from 'react';
import { Table } from 'antd';
import { playBgMusic, stopBgMusic, setDisabledSounds } from '../utils/audio';
import {saveLocalData, getLocalData} from '../utils/storage';


// Simple icons as SVGs for demo (you'd likely use real icons or a package)
export const HamburgerIcon = ({ onClick }) => (
    <button className="hamburger" aria-label="Open menu" onClick={onClick}>
      <svg width="36" height="36" viewBox="0 0 36 36" fill="white">
        <rect y="8" width="36" height="3" rx="1.5"/>
        <rect y="16.5" width="36" height="3" rx="1.5"/>
        <rect y="25" width="36" height="3" rx="1.5"/>
      </svg>
    </button>
  );

export function GameSummaryBar({ payouts, winners }) {
    return (
      <div className="game-summary">
        <div className="summary-label">Payouts:</div>
        <div className="summary-value">{payouts} Br</div>
        <div className="summary-label winners">Winners:</div>
        <div className="summary-value">{winners}</div>
      </div>
    );
  }
  
  
  export function BalanceBar({ balance }) {
    return (
      <div className="balance-bar">
        <div className="balance-label">Balance:</div>
        <div className="balance-value">{balance} Br</div>
      </div>
    );
  }
  
  
  export function HamburgerMenu({ open, onClose, betHistoryOpen, setBetHistoryOpen , setMenuOpen , musicOn, audioOn, setMusicOn, setAudioOn }) {
    // Example toggles (not implemented)
    


    useEffect(() => {
      setDisabledSounds(!audioOn);
    }, [audioOn]);

   

    useEffect(() => {
      //setMusicOn(getLocalData('musicOn')?.musicOn)
      //setAudioOn(getLocalData('audioOn')?.audioOn)

    }, []);
  
  
    const handleHistoryClick = () => {
      setBetHistoryOpen(true);
      onClose();
      
    }
  
    return open ? (
      <Modal open={open} onClose={onClose}>
        <div className="modal-backdrop">
          <div className="modal-content" >
        <nav className="hamburger-menu">
          <span style = {{fontWeight : 700 }}>Settings</span>
          <span style={{float : "right", cursor : "pointer"}} onClick={onClose}>X</span>
          <div className="menu-switch" style={{marginTop : "15px" , cursor : "pointer" }} >
            <span>Music</span>
            <button
              className={`toggle-btn${musicOn ? " on" : ""}`}
              onClick={() => {
                saveLocalData('musicOn', {musicOn: !musicOn});
                setMusicOn(v => !v);

                if(musicOn){
                  stopBgMusic();
                }
                else{
                  
                  playBgMusic();
                }
                
              }}
              type="button"
            >
              {musicOn ? "On" : "Off"}
            </button>
          </div>
          <div className="menu-switch">
            <span>Audio</span>
            <button
              className={`toggle-btn${audioOn ? " on" : ""}`}
              onClick={() => {
                saveLocalData('audioOn', {audioOn: !audioOn});
                setAudioOn(v => !v);
              }}
              type="button"
            >
              {audioOn ? "On" : "Off"}
            </button>
          </div>
          <div className="menu-list">
            <button className="menu-link" type="button" onClick={handleHistoryClick}>
              Bet History
            </button>
          </div>
        </nav>
        </div>
        </div>
      </Modal>
    ) : null
  }
  
  
  
  export function BetHistory({open ,  onClose  , betHistory}) {
    if(!open) return null;
    // Fake last 10 bet data
    
    const columns = [
      {
        title: <span style={{ color: "#ccccde" }}>Date</span>,
        dataIndex: "date",
        key: "date",
        render: val => <span style={{ color: "#bbc" }}>{val}</span>,
      },
      {
        title: <span style={{ color: "#ccccde" }}>Bet</span>,
        dataIndex: "bet",
        key: "bet",
        render: val => <span style={{ color: "#eee" }}>{val} Br</span>,
        align: "right",
      },
      {
        title: <span style={{ color: "#ccccde" }}>Multiplier</span>,
        dataIndex: "multiplier",
        key: "multiplier",
        render: val =>
          val === 0
            ? <span style={{ color: "#9a3232" }}>–</span>
            : <span style={{ color: "#4ccd7b" }}>{val.toFixed(2)}x</span>,
        align: "right",
      },
      {
        title: <span style={{ color: "#ccccde" }}>Win</span>,
        dataIndex: "win",
        key: "win",
        render: val =>
          val === 0
            ? <span style={{ color: "#9a3232" }}>0</span>
            : <span style={{ color: "#ffe480", fontWeight: 500 }}>{val.toLocaleString()} Br</span>,
        align: "right",
      },
    ];
  
    return open ? (
      <Modal open={open} onClose={onClose}>
        <div
          className="bet-history"
          style={{
            position: "fixed",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -60%)",
            zIndex: 100000,
            background: "#18181b",
            padding: "24px 20px",
            borderRadius: "15px",
            maxWidth: 540,
            minWidth: 310,
            width: "90vw",
            margin: "0",
            boxShadow: "0 0 24px #0007",
          }}
        >
          {/* Close Icon Top Right */}
          <button
            aria-label="Close"
            onClick={onClose}
            style={{
              position: "absolute",
              top: 13,
              right: 13,
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: 6,
              zIndex: 1100,
            }}
          >
            <svg width="22" height="22" viewBox="0 0 22 22">
              <line x1="4" y1="4" x2="18" y2="18" stroke="#ccc" strokeWidth="2.3" strokeLinecap="round"/>
              <line x1="4" y1="18" x2="18" y2="4" stroke="#ccc" strokeWidth="2.3" strokeLinecap="round"/>
            </svg>
          </button>
          <h2 style={{ color: "#eee", marginBottom: 18, fontWeight: 600, textAlign: "center" }}>Bet History</h2>
          <Table
            columns={columns}
            dataSource={betHistory}
            pagination={false}
            size="middle"
            rowClassName={(rec, i) => rec.win === 0 ? "bet-row-loss" : "bet-row-win"}
            style={{ background: "transparent" }}
            bordered={false}
          />
          <style>{`
            .bet-history {
              position: fixed !important;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
            .bet-history table {
              background: transparent !important;
            }
            .bet-history .ant-table-thead > tr > th {
              background: #1d1d22 !important;
              color: #cee;
              border: none !important;
            }
            .bet-history .ant-table-tbody > tr > td {
              background: #212127 !important;
              border-bottom: 1px solid #22242b !important;
              color: #ddd;
            }
            .bet-history .ant-table-tbody > tr.bet-row-loss > td {
              color: #943656 !important;
              background: #1d181a !important;
            }
            .bet-history .ant-table-tbody > tr.bet-row-win > td {
              background: #212522 !important;
            }
            .bet-history .ant-table {
              border-radius: 9px;
              overflow: hidden;
            }
          `}</style>
        </div>
      </Modal>
    ) : null;
  }